import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

declare global {
  interface Window {
    M?: {
      Collapsible: {
        init: (elems: NodeListOf<Element> | Element[], options?: { accordion?: boolean }) => void;
        getInstance: (elem: Element) => { destroy: () => void } | null;
      };
    };
  }
}

function isActive(path: string, current: string): string {
  if (path === '/ranking') {
    return current === '/ranking' ? 'active' : '';
  }
  return current.startsWith(path) ? 'active' : '';
}

export function RankingSidebar() {
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const el = document.getElementById('ranking-collapsible');
    if (!el || !window.M?.Collapsible) return;

    const existing = window.M.Collapsible.getInstance(el);
    existing?.destroy();
    window.M.Collapsible.init(el.querySelectorAll('.collapsible'), { accordion: true });
  }, [path]);

  return (
    <aside className="ranking-sidebar">
      <ul className="sidebar-menu collapsible" id="ranking-collapsible">
        <li className={isActive('/ranking', path) || path === '/ranking/player' ? 'active' : ''}>
          <Link to="/ranking" className="sidebar-link">
            <span className="sidebar-icon">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden>
                <path
                  d="M10 10a4 4 0 100-8 4 4 0 000 8zM2 18a8 8 0 0116 0v1H2v-1z"
                  stroke="#e6c98a"
                  strokeWidth="1.5"
                />
              </svg>
            </span>
            Player
          </Link>
        </li>
        <li className={isActive('/ranking/guild', path)}>
          <Link to="/ranking/guild" className="sidebar-link">
            <span className="sidebar-icon">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden>
                <path
                  d="M10 2l2.39 4.84L18 7.27l-3.91 3.81L14.18 18 10 15.27 5.82 18l.91-6.92L2 7.27l5.61-.43L10 2z"
                  stroke="#e6c98a"
                  strokeWidth="1.5"
                />
              </svg>
            </span>
            Guild
          </Link>
        </li>

        <li className={path.includes('/ranking/mastery') ? 'active' : ''}>
          <div className="collapsible-header sidebar-toggle">
            <span className="sidebar-icon">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden>
                <path d="M4 4h12v2H4V4zm0 5h12v2H4V9zm0 5h12v2H4v-2z" stroke="#ffd700" strokeWidth="1.5" />
              </svg>
            </span>
            Mastery
          </div>
          <div className="collapsible-body">
            <ul className="sidebar-ul">
              {['blade', 'sword', 'bow', 'glaive', 'dagger', 'warrior', 'wizzard'].map((type) => (
                <li key={type} className={isActive(`/ranking/mastery/${type}`, path)}>
                  <Link to={`/ranking/mastery/${type}`}>{type.charAt(0).toUpperCase() + type.slice(1)}</Link>
                </li>
              ))}
            </ul>
          </div>
        </li>

        <li className={path.includes('/ranking/arena') ? 'active' : ''}>
          <div className="collapsible-header sidebar-toggle">
            <span className="sidebar-icon">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden>
                <path d="M4 4h12v2H4V4zm0 5h12v2H4V9zm0 5h12v2H4v-2z" stroke="#ffd700" strokeWidth="1.5" />
              </svg>
            </span>
            Arena PVP
          </div>
          <div className="collapsible-body">
            <ul className="sidebar-ul">
              {['fortress', 'survival', 'jobkill', 'battlearena', 'ctf', 'freepvp'].map((type) => (
                <li key={type} className={isActive(`/ranking/arena/${type}`, path)}>
                  <Link to={`/ranking/arena/${type}`}>
                    {type === 'jobkill'
                      ? 'Job Kill'
                      : type === 'battlearena'
                        ? 'Battle Arena'
                        : type === 'freepvp'
                          ? 'Free PVP'
                          : type.charAt(0).toUpperCase() + type.slice(1)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </li>
      </ul>
    </aside>
  );
}
